import React from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import { Box, Svg, Text } from '@hopskipdrive/react-components';
import { PageHeading } from '@rideiq/shared/components/PageHeading';

import { ButtonLink } from '../../components';

import { Container } from './styles';

const NotFound: React.FC = () => {
  const isValidRoute = useMatch('*/not_found');
  const location = useLocation();
  const routeParts = location.pathname.split('/');
  const previousRoute = isValidRoute ? `/${routeParts[1]}` : '/';

  return (
    <Container>
      <Box display="flex" alignItems="flex-start" flexDirection="column" gap="26px">
        <Svg icon="hsd-logo" width={104} height={93} alt="HopSkipDrive logo" />
        <Box display="flex">
          <PageHeading variant="h1" textColor="primaryText" fontWeight={600} mr={4}>
            Error 404.
          </PageHeading>
          <PageHeading variant="h1" textColor="secondaryText" fontWeight={600}>
            Cannot find the page
          </PageHeading>
        </Box>
        <Text variant="body1" textColor="secondaryText" fontWeight={400}>
          The page you are trying to open is not available.
        </Text>
        <ButtonLink variant="contained" color="secondary" size="large" to={previousRoute}>
          Go Back
        </ButtonLink>
      </Box>
    </Container>
  );
};

export default NotFound;
